const workflow = {
  feilds: [
    {
      id: 1,
      label: "Billing",
      placeholder: "Select Billing",
      icon: "billing.png",
      rules: [],
      errors: [],
      valid: false,
      state: "",
      relation: false,
      relationvalue: [],
      mode: "single",
      type: "checkbox",
      disable: false,
      value: false,
    },
    {
      id: 2,
      label: "Appointment",
      placeholder: "Select Appointment",
      icon: "appointment.png",
      rules: [],
      errors: [],
      relation: false,
      relationvalue: [],
      valid: false,
      state: "",
      mode: "single",
      type: "checkbox",
      disable: false,
      value: null,
    },
    {
      id: 3,
      label: "Patient Arrival",
      placeholder: "Select Patient Arrival",
      icon: "receipt.png",
      rules: [],
      errors: [],
      valid: false,
      state: "",
      relation: false,
      relationvalue: [],
      mode: "single",
      type: "checkbox",
      disable: false,
      value: null,
    },
    {
      id: 4,
      label: "Check In",
      placeholder: "Select Check In",
      icon: "checkin.png",
      rules: [],
      relation: false,
      relationvalue: [],
      errors: [],
      valid: false,
      state: "",
      mode: "single",
      type: "checkbox",
      disable: false,
      value: null,
    },
    {
      id: 5,
      label: "Check Out",
      placeholder: "Select Check Out",
      icon: "checkout.png",
      rules: [],
      relation: false,
      relationvalue: [],
      errors: [],
      valid: false,
      state: "",
      mode: "single",
      type: "checkbox",
      disable: false,
      value: null,
    },
    {
      id: 6,
      label: "Dispatch",
      placeholder: "Select Dispatch",
      icon: "dispatch.png",
      rules: [],
      relation: true,
      relationvalue: [{ id: 3 }],
      errors: [],
      valid: false,
      state: "",
      mode: "single",
      type: "checkbox",
      disable: false,
      value: null,
    },
  ],
};

export default workflow;
